import { detectOS } from 'detect-browser';

const osInfo = {
  done: false,
  isMac: false,
  isWindows: false,
}

export const getOsInfo = () => {
  if (osInfo.done) {
    return osInfo;
  }

  if (osInfo.done) {
    return osInfo;
  }

  const os = detectOS(navigator.userAgent);

  osInfo.done = true;
  osInfo.isMac = os === 'Mac OS';
  osInfo.isWindows = os.startsWith('Windows')

  return osInfo;
}

export const useDetectOS = () => {
  return getOsInfo();
}